import React from 'react';
import { Modal } from '../../../components/containers/Modal';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { GetUnreadSiteNewsQuery } from '../../../models/graphql';
import { WhatsNewItem } from '../WhatsNewItem';
import classNames from 'classnames';

export type WhatsNewModalViewProps = {
  //
  onClose: VoidFunction;
  showAllHandler: VoidFunction;
  news: GetUnreadSiteNewsQuery['unreadSiteNews'] | null;
  loading: boolean;
};

export const WhatsNewModalView = (props: WhatsNewModalViewProps): JSX.Element | null => {
  const { onClose, showAllHandler, news, loading } = props;
  return news && news.length ? (
    <Modal
      size={'large'}
      title={"What's New"}
      primaryButtonAction={showAllHandler}
      primaryButtonColor={ButtonColorsEnum.secondary}
      primaryButtonTitle={'View all Updates'}
      primaryButtonLoading={loading}
      onClose={onClose}
      closeOnClickOutside={false}
      closeOnEsc={true}>
      {news.map((item, index, { length }) => (
        <div
          key={`news_item_${index}_${item.id}`}
          className={classNames(length === index + 1 ? '' : 'margin-bottom-small-24')}>
          <WhatsNewItem
            text={item.text}
            date={item.date}
            title={item.title}
            key={`what'snew_item_${index}`}
            excludeHr={length === index + 1}
          />
        </div>
      ))}
    </Modal>
  ) : null;
};
